/* eslint-disable jsx-a11y/anchor-is-valid */
import "./AddSupplierWidget.scss";
import Icon from "../../../assets/icons";
import { useState } from "react";
import secondaryComponents from "..";
import { UserDangerIcon, UserSuccessIcon } from "../../../assets/svgIcons";

const AddSupplierWidgetModal = ({
  closeModal = () => {},
  handleFetchSuppliers = () => {},
}) => {
  const [isCreateMultipleSupplier, setIsCreateMultipleSupplier] =
    useState(false);
  const [isCreateSingleSupplier, setIsCreateSingleSupplier] = useState(false);

  if (isCreateSingleSupplier) {
    return (
      <secondaryComponents.SupplierForm
        closeWidget={closeModal}
        handleFetchSuppliers={handleFetchSuppliers}
      />
    );
  }

  return (
    <>
      <div className="add-product-widget">
        <a
          className="add-product-widget__item"
          onClick={() => setIsCreateSingleSupplier(true)}
        >
          <div className="icon orange">
            <UserDangerIcon />
          </div>
          <div>
            <p className="font-weight-semibold dark--text">Single Supplier</p>
            <p className="smallest-text-size">Create a new supplier record</p>
          </div>
          <img className="ml-auto" src={Icon.chevron_right_arrow} alt="" />
        </a>

        <a
          className="add-product-widget__item"
          onClick={() => {
            setIsCreateMultipleSupplier(true);
          }}
        >
          <div className="icon green">
            <UserSuccessIcon />
          </div>
          <div>
            <p className="font-weight-semibold dark--text">
              Bulk Upload Suppliers
            </p>
            <p className="smallest-text-size">
              Migrate all your suppliers into Lumi Business with .CSV bulk
              upload
            </p>
          </div>
          <img className="ml-auto" src={Icon.chevron_right_arrow} alt="" />
        </a>
      </div>

      {/* batch upload */}
      <secondaryComponents.Modal
        isActive={isCreateMultipleSupplier}
        closeModal={() => {
          setIsCreateMultipleSupplier(false);
        }}
        width={700}
      >
        <secondaryComponents.AddMultipleSuppliers
          closeWidget={() => setIsCreateMultipleSupplier(false)}
          handleFetchSuppliers={handleFetchSuppliers}
        />
      </secondaryComponents.Modal>
    </>
  );
};

export default AddSupplierWidgetModal;
